<template>
  <div>
    <span v-for="item in stations" :key="item.id">
      <div v-if="item.id == $route.params.id" class="row">
        <div class="left-container" :class="{ p012: item.station_type == 3 }">
          <div v-if="checkHttps(item.note)">
            <div v-if="ava_width >= 768" class="row">
              <div class="col-7 px-0">
                <CctvStream
                  :streamUrl="extractCctvUrl(item.note)"
                  class="comShadow mx-auto px-0"
                  style="border-radius: 15px; height: 29vh"
                />
              </div>
              <div class="col-5 pl-0">
                <TableMap
                  :stations="item"
                  :status="status"
                  :loading_i="loading_i"
                  class="mx-auto"
                  style="border-radius: 15px; height: 29vh"
                />
              </div>
            </div>
            <CctvStreamMobile
              v-else
              :streamUrl="extractCctvUrl(item.note)"
              class="mx-auto comShadow border"
            />
          </div>
          <TableMap
            v-else
            :stations="item"
            :status="status"
            :loading_i="loading_i"
            class="mx-auto comShadow border"
            style="border-radius: 15px"
          />
        </div>
      </div>
    </span>
    <div style="border-radius: 15px" class="mt-2 bg-white">
      <!-- <dataset
        class="box comShadow px-3"
        v-slot="{ ds }"
        :ds-data="filterData"
        :ds-sortby="sortBy"
        style="height: 62vh"
      > -->
      <dataset
        class="box comShadow px-3"
        v-slot="{ ds }"
        :ds-data="pagedData"
        :ds-sortby="sortBy"
        style="height: 62vh"
      >
        <div
          class="row mt-1"
          :data-page-count="ds.dsPagecount"
          style="height: 10vh; display: flex; align-items: center"
        >
          <div
            v-if="loading_i && role == 'is_guess'"
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <i
              class="zmdi zmdi-spinner zmdi-hc-spin"
              style="font-size: 1.5rem"
            ></i>
          </div>

          <div class="col-md d-flex justify-content-center mt-1">
            <div v-if="role != 'is_guess'">
              <i
                v-if="loading_data"
                class="zmdi zmdi-spinner zmdi-hc-spin mx-2"
                style="font-size: 1.2rem"
              ></i>
              <i
                v-if="loading_date_data"
                class="zmdi zmdi-rotate-right zmdi-hc-spin mx-2"
                style="font-size: 1.2rem"
              ></i>
              <input
                name="from"
                type="date"
                v-model="startDate"
                @change="search"
                title="Data Awal"
                style="font-size: 0.8rem"
                :class="{ darkMode: isDarkMode }"
              />
              <label
                for="to"
                class="px-2"
                style="font-size: 0.8rem; font-weight: normal"
                >-</label
              >
              <input
                name=""
                type="date"
                v-model="endDate"
                @change="search"
                title="Data Akhir"
                style="font-size: 0.8rem"
                :class="{ darkMode: isDarkMode }"
              />
              <div class="col-md d-inline mx-3">
                <button
                  class="btn btn-sm btn-primary"
                  type="button"
                  @click="download"
                  title="Download sesuai filter"
                  style="font-size: 0.8rem"
                >
                  <i
                    v-if="loading_dw"
                    class="zmdi zmdi-rotate-right zmdi-hc-spin"
                    style="font-size: 1.2rem; margin-right: 3px"
                  ></i>
                  <span><i class="zmdi zmdi-download"></i></span>
                </button>
              </div>

              <div class="col-md d-inline mx-1" v-if="hasCCTV">
                <button
                  type="button"
                  class="btn btn-sm btn-success"
                  data-bs-toggle="modal"
                  style="font-size: 0.8rem"
                  data-bs-target="#cctvRecording"
                >
                  <span>Recording</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <p v-if="csv_code">File status: {{ csv_code }}</p>
        <div class="row mt-1">
          <div class="col-md-12">
            <div
              class="table-responsive"
              style="max-height: 50vh; overflow-y: auto"
            >
              <table
                class="table table-hover table-responsive text-nowrap text-center table-borderless bg-white table-bordered"
                :class="{ darkMode: isDarkMode }"
              >
                <thead
                  class="table-light"
                  style="position: sticky; top: 0; z-index: 10"
                >
                  <tr>
                    <th
                      scope="col"
                      class="thClass"
                      :class="{ darkerMode: isDarkMode }"
                    >
                      #
                    </th>
                    <th
                      v-for="(th, index) in cols"
                      :key="th.field"
                      :class="['sort', th.sort, { darkerMode: isDarkMode }]"
                      @click="click($event, index)"
                      class="thClass"
                    >
                      {{ th.name }} <i class="gg-select float-right"></i>
                    </th>
                  </tr>
                </thead>
                <dataset-item tag="tbody">
                  <template #default="{ row, index }">
                    <tr style="cursor: pointer" @click="selectRow(index)">
                      <td scope="row">{{ index + 1 }}</td>
                      <td>{{ formatDate(row.waktu) }}</td>
                      <td>{{ formatTime(row.waktu) }}</td>
                      <td
                        v-for="(item, index) in conf_2(
                          row.weather_data,
                          row.symbol,
                        )"
                        :key="index"
                      >
                        {{ item.data }} {{ item.symbol }}
                      </td>
                      <td v-if="balai == 0">{{ row.bat.toFixed(2) }} v</td>
                      <td v-if="balai == 0">{{ row.temp.toFixed(2) }} C</td>
                    </tr>
                  </template>
                </dataset-item>
              </table>
            </div>
          </div>
        </div>
        <!-- <div class="d-flex flex-md-row flex-column justify-content-end align-items-center">
          <dataset-pager style="font-size: 0.9rem" class="mx-3" />
        </div> -->
        <div
          class="d-flex justify-content-between align-items-center px-1 pt-2 pb-1"
          style="font-size: 0.82rem; color: #696969"
        >
          <span>
            Showing
            {{
              filterData.length === 0
                ? 0
                : (currentTablePage - 1) * tablePageSize + 1
            }}–{{
              Math.min(currentTablePage * tablePageSize, filterData.length)
            }}
            of {{ filterData.length }} entries
          </span>
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li
                class="page-item"
                :class="{ disabled: currentTablePage === 1 }"
              >
                <button class="page-link" @click="prevTablePage">
                  &#8592;
                </button>
              </li>
              <li class="page-item disabled">
                <span class="page-link"
                  >{{ currentTablePage }} / {{ tableTotalPages }}</span
                >
              </li>
              <li
                class="page-item"
                :class="{ disabled: currentTablePage === tableTotalPages }"
              >
                <button class="page-link" @click="nextTablePage">
                  &#8594;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </dataset>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TableMap from "@/components/Station/Data/TableMap.vue";
import moment from "moment";
import CctvStream from "@/components/CctvStream.vue";
import CctvStreamMobile from "@/components/CctvStreamMobile.vue";
import {
  Dataset,
  DatasetItem,
  // DatasetPager,
  // DatasetShow,
} from "vue-dataset";

export default {
  name: "TableData",
  components: {
    Dataset,
    DatasetItem,
    // DatasetPager,
    // DatasetShow,
    TableMap,
    CctvStream,
    CctvStreamMobile,
  },
  props: ["stations", "loading_i", "status"],

  data() {
    return {
      currentTablePage: 1,
      tablePageSize: 20,
      ava_width: null,
      csv_code: null,
      file: null,
      csvFile: null,
      namaPos: "",
      type: "",
      role: undefined,
      json_data: [],
      nama: "",
      cols: [],
      selectedType: "",
      startDate: null,
      endDate: null,
      sensors: [],
      first_date: null,
      last_date: null,
      loading_dw: false,
      loading_date_data: false,
      loading_data: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 50,
      list_cctv: [],
      cctvAuth: {
        username: "palu",
        password: "335bcd80-92bb-4b3f-ac7d-56eab65d9279",
      },
      baseStreamURL: "https://stream1.blitztechnology.tech/awlr-untad/cctv1/",
      apiEndpoint:
        "https://stream1.blitztechnology.tech/api/project/palu/site/awlr-untad/cctv/cctv1/",
    };
  },
  computed: {
    pagedData() {
      const start = (this.currentTablePage - 1) * this.tablePageSize;
      return this.filterData.slice(start, start + this.tablePageSize);
    },
    tableTotalPages() {
      return Math.max(
        1,
        Math.ceil(this.filterData.length / this.tablePageSize),
      );
    },

    hasCCTV() {
      return this.stations.some(
        (station) =>
          station.note && /cctv:\s*https?:\/\/[^\s]+/.test(station.note),
      );
    },
    filteredList() {
      return this.list_cctv.filter((video) => {
        const formatted = this.formatFilenameToDate(video).toLowerCase();
        return formatted.includes(this.searchQuery.toLowerCase());
      });
    },
    totalPages() {
      return Math.ceil(this.filteredList.length / this.itemsPerPage);
    },
    paginatedList() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredList.slice(start, start + this.itemsPerPage);
    },
    sortBy() {
      return this.cols.reduce((acc, o) => {
        if (o.sort) {
          o.sort === "asc" ? acc.push(o.field) : acc.push("-" + o.field);
        }
        return acc;
      }, []);
    },
    filterData() {
      let filterType = this.selectedType;
      let startDate = this.localStart(this.startDate);
      let endDate = this.localEnd(this.endDate);

      const itemsByType = filterType
        ? this.json_data.filter((item) => item.type === filterType)
        : this.json_data;

      return itemsByType.filter((item) => {
        const itemDate = new Date(item.waktu);
        if (startDate && endDate) {
          return startDate <= itemDate && itemDate <= endDate;
        }
        if (startDate && !endDate) {
          return startDate <= itemDate;
        }
        if (!startDate && endDate) {
          return itemDate <= endDate;
        }
        return true;
      });
    },
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    },
  },
  watch: {
    // filterData(newData) {
    //   this.$emit("filteredDataChanged", newData);
    // },
    filterData() {
      this.$emit("filteredDataChanged", this.filterData);
      this.currentTablePage = 1; // reset on date filter change
    },

    dataStation(newVal) {
      this.$emit("update-filtered-data", newVal);
    },
  },
  methods: {
    prevTablePage() {
      if (this.currentTablePage > 1) this.currentTablePage--;
    },
    nextTablePage() {
      if (this.currentTablePage < this.tableTotalPages) this.currentTablePage++;
    },
    formatFilenameToDate(filename) {
      const match = filename.match(/_(\d{8})_(\d{6})/);
      if (!match) return filename;
      const date = match[1];
      const time = match[2];
      const formattedDate = `${date.slice(6, 8)}-${date.slice(
        4,
        6,
      )}-${date.slice(0, 4)}`;
      const formattedTime = `${time.slice(0, 2)}:${time.slice(
        2,
        4,
      )}:${time.slice(4, 6)}`;
      return `${formattedDate} ${formattedTime}`;
    },
    // downloadVideo(filename) {
    //   const user = 'palu'
    //   const pass = '335bcd80-92bb-4b3f-ac7d-56eab65d9279'
    //   const url = `https://${user}:${pass}@stream1.blitztechnology.tech/awlr-untad/cctv1/${filename}`;
    //   // Create a temporary anchor element
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.setAttribute('download', filename); // this hints the browser to download
    //   link.setAttribute('target', '_blank'); // optional if server forces auth dialog
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },
    // async fetchCCTVList() {
    //   try {
    //     const response = await axios.get('https://stream1.blitztechnology.tech/api/project/palu/site/awlr-untad/cctv/cctv1/', {
    //       auth: {
    //         username: 'palu',
    //         password: '335bcd80-92bb-4b3f-ac7d-56eab65d9279'
    //       }
    //     });
    //     if (response.data?.data) {
    //       this.list_cctv = response.data.data
    //         .slice()
    //         .sort((a, b) => {
    //           const dateA = this.extractDateTime(a);
    //           const dateB = this.extractDateTime(b);
    //           return dateB - dateA;
    //         });
    //     }
    //   } catch (error) {
    //     console.error('Error fetching CCTV list:', error);
    //   }
    // },
    downloadVideo(filename) {
      const { username, password } = this.cctvAuth;
      const url = `https://${username}:${password}@stream1.blitztechnology.tech/awlr-untad/cctv1/${filename}`;

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async fetchCCTVList() {
      try {
        const response = await axios.get(this.apiEndpoint, {
          auth: this.cctvAuth,
        });

        const data = response.data?.data;
        if (Array.isArray(data)) {
          this.list_cctv = data.slice().sort((a, b) => {
            const dateA = this.extractDateTime(a);
            const dateB = this.extractDateTime(b);
            return dateB - dateA;
          });
        }
      } catch (error) {
        console.error("Error fetching CCTV list:", error);
      }
    },

    // extractDateTime(item) {
    //   // Replace this with your actual logic to extract datetime from `item`
    //   return new Date(item.timestamp || item.date || 0).getTime();
    // },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },

    extractDateTime(filename) {
      const match = filename.match(/_(\d{8})_(\d{6})/);
      if (!match) return new Date(0);

      const date = match[1];
      const time = match[2];

      const year = parseInt(date.slice(0, 4));
      const month = parseInt(date.slice(4, 6)) - 1; // Month is 0-based
      const day = parseInt(date.slice(6, 8));
      const hour = parseInt(time.slice(0, 2));
      const minute = parseInt(time.slice(2, 4));
      const second = parseInt(time.slice(4, 6));

      return new Date(year, month, day, hour, minute, second);
    },
    selectRow(index) {
      // console.log("Row clicked inside TableData.vue:", index);
      this.$emit("rowSelected", index); // ✅ Emit the index to Data.vue
    },
    // checkHttps(note) {
    //   return note && note.includes('https');
    // },
    checkHttps(note) {
      if (!note) return false;

      // Use regex to extract the URL
      const match = note.match(/https?:\/\/\S+/);
      return match !== null;
    },

    extractCctvUrl(note) {
      if (!note) return null;

      // Extract URL using regex
      const match = note.match(/https?:\/\/\S+/);
      return match ? match[0] : null;
    },

    conf_2(a, b) {
      return a.map((card, i) => {
        return {
          data: card,
          symbol: b[i],
        };
      });
    },
    click(event, i) {
      let toset;
      const sortEl = this.cols[i];
      if (!event.shiftKey) {
        this.cols.forEach((o) => {
          if (o.field !== sortEl.field) {
            o.sort = "";
          }
        });
      }
      if (!sortEl.sort) {
        toset = "asc";
      }
      if (sortEl.sort === "desc") {
        toset = event.shiftKey ? "" : "asc";
      }
      if (sortEl.sort === "asc") {
        toset = "desc";
      }
      sortEl.sort = toset;
    },
    async reCall() {
      await axios.get(
        `${this.$baseURL}/data/${this.$route.params.id}/${this.user_id}`,
        {
          headers: {
            Authorization: `Token ${this.token}`,
          },
        },
      );
    },
    async loadData() {
      this.loading_data = true;
      let result = await axios
        .get(`${this.$baseURL}/data/${this.$route.params.id}/${this.user_id}`, {
          headers: {
            Authorization: `Token ${this.token}`,
          },
        })

        .catch(function (e) {
          console.log(e);
        });

      let raw_table = result.data[1][0].table;
      this.nama = `${result.data[0].station_name}`;
      let sensor_label = result.data[1][0].table.array_table_label;
      this.windRose_label = result.data[1][0].table.array_table_label;
      let date = raw_table.date;
      let battery = raw_table.battery;
      let temperature = raw_table.temperature;
      let rw_data = raw_table.weather_data;
      let raw_symbol = raw_table.array_act_symbol;

      let a = {};

      date.forEach((waktu, i) => {
        let bat = battery[i];
        let temp = temperature[i];
        let weather_data = rw_data[i];
        let symbol = raw_symbol[i];

        a = { waktu, bat, temp, weather_data, symbol };

        this.json_data.push(a);
      });

      this.cols = [
        {
          name: "Tanggal",
        },
        {
          name: "Waktu",
        },
      ];

      for (let i = 0; i < sensor_label.length; i++) {
        this.cols.push({
          name: sensor_label[i],
        });
      }
      if (this.balai == 0) {
        this.cols.push({
          name: "Battery",
        });
        this.cols.push({
          name: "Temperature",
        });
      }
      if (result.status == 200) {
        this.loading_data = false;
      }
    },
    localStart(date) {
      if (!date || !date.includes("-")) return date;
      const [YYYY, MM, DD] = date.split("-");
      return new Date(`${YYYY}-${MM}-${DD} 00:00:00`);
    },
    localEnd(date) {
      if (!date || !date.includes("-")) return date;
      const [YYYY, MM, DD] = date.split("-");
      return new Date(`${YYYY}-${MM}-${DD} 23:59:00`);
    },
    formatDate(date) {
      var monthShortNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ];
      var d = new Date(date),
        year = d.getFullYear(),
        month = "" + d.getMonth(),
        day = "" + d.getDate();

      if (day.length < 2) day = "0" + day;
      return [day, monthShortNames[month], year].join(" ");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = d.getHours(),
        minute = d.getMinutes(),
        second = d.getSeconds();

      // Format hours, minutes, and seconds to always have two digits
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;

      return [hour, minute, second].join(":");
    },
    download() {
      this.loading_dw = true;
      if (this.role == "is_staff" || this.role == "is_superuser") {
        axios
          .post(
            `${this.$baseURL}/excel/`,
            {
              station_id: this.$route.params.id,
              first_date: this.startDate,
              last_date: this.endDate,
            },
            {
              responseType: "arraybuffer",
              headers: {
                Authorization: `Token ${this.token}`,
              },
            },
          )
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            if (this.startDate && this.endDate) {
              link.setAttribute(
                "download",
                `Laporan Pembacaan Sensor ${this.nama} ${this.startDate} sd ${this.endDate}.xlsx`,
              );
            } else {
              link.setAttribute(
                "download",
                `Laporan Pembacaan Sensor ${this.nama}.xlsx`,
              );
            }
            document.body.appendChild(link);
            link.click();

            if (response.status == 200) {
              this.loading_dw = false;
            }
          })
          .catch((error) => console.log(error));
      } else if (this.role == "is_guess") {
        axios
          .post(
            `${this.$baseURL}/excel/`,
            {
              station_id: this.$route.params.id,
              first_date: null,
              last_date: null,
            },
            {
              responseType: "arraybuffer",
              headers: {
                Authorization: `Token ${this.token}`,
              },
            },
          )
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Laporan Pembacaan Sensor ${this.nama}.xlsx`,
            );
            document.body.appendChild(link);
            link.click();

            if (response.status == 200) {
              this.loading_dw = false;
            }
          })
          .catch((error) => console.log(error));
      }
    },
    async searchData(from, until) {
      await axios
        .post(
          `${this.$baseURL}/data-date/`,
          {
            station_id: this.$route.params.id,
            user_id: this.user_id,
            first_date: from,
            last_date: until,
          },
          {
            headers: {
              Authorization: `Token ${this.token}`,
            },
          },
        )
        .then((result) => {
          this.json_data = [];
          let raw_table = result.data[1][0].table;
          this.nama = `${result.data[0].station_name}`;
          let sensor_label = result.data[1][0].table.array_table_label;

          let date = raw_table.date;
          let battery = raw_table.battery;
          let temperature = raw_table.temperature;
          let rw_data = raw_table.weather_data;
          let raw_symbol = raw_table.array_act_symbol;

          let a = {};

          date.forEach((waktu, i) => {
            let bat = battery[i];
            let temp = temperature[i];
            let weather_data = rw_data[i];
            let symbol = raw_symbol[i];

            a = { waktu, bat, temp, weather_data, symbol };

            this.json_data.push(a);
          });

          this.cols = [
            {
              name: "Tanggal",
              field: "waktu",
              sort: "desc",
            },
            {
              name: "Waktu",
            },
          ];

          for (let i = 0; i < sensor_label.length; i++) {
            this.cols.push({
              name: sensor_label[i],
            });
          }
          if (this.balai == 0) {
            this.cols.push({
              name: "Battery",
            });
            this.cols.push({
              name: "Temperature",
            });
          }
          if (result.status == 200) {
            this.loading_date_data = false;
          }
        })
        .catch((error) => console.log(error));
    },
    async search() {
      const from = this.startDate;
      const until = this.endDate;
      this.loading_date_data = true;
      const diffDays = moment(this.endDate).diff(
        moment(this.startDate),
        "days",
      );
      const today = moment().format("YYYY-MM-DD");
      // const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const monthAgo = moment().subtract(31, "days").format("YYYY-MM-DD");

      if (diffDays > 31) {
        this.searchData(monthAgo, today);
      } else {
        this.searchData(from, until);
      }
    },
    onChangeFileUpload(event) {
      this.csvFile = event.target.files[0];
    },
    modified() {
      let formData = new FormData();
      formData.append("station_id", this.$route.params.id);
      formData.append("csvFile", this.csvFile);

      axios
        .post(`${this.$baseURL}/csv/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${this.token}`,
          },
        })
        .then((r) => {
          console.log("status: ", r.status);

          if (r.status == 204) {
            this.csv_code = "File uploaded successfully, reload the page";
            // location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
          this.csv_code = "Error uploading the file. Please try again."; // Display your custom error message
          // this.csv_code = error;
        });
    },
  },
  created() {
    this.ava_width = screen.availWidth;

    this.userJSONParse();
    this.loadData();
    // console.log("Initial stations value:", this.stations);
  },
  async mounted() {
    // this.gStation();
    this.fetchCCTVList();
  },
};
</script>
<style scoped src="@/assets/css/figma.css"></style>
<style scoped>
select,
input,
input:focus {
  border-color: whitesmoke;
  padding: 5px 10px;
  background-color: #fff;
  border-radius: 7px;
  color: grey;
}

th,
td {
  padding: 2px !important;
}

.thClass {
  font-weight: normal;
  color: #696969;
  font-size: 0.9rem;
  padding: 0 5px !important;
}

td {
  font-size: 0.9rem;
}

.row {
  display: flex;
  /* Use flexbox to create a row layout */
  align-items: flex-start;
  /* Align items at the top of the container */
}

.left-container {
  flex: 1;
  /* Allow the container to take up available space */
  /* padding: 0 5px; */
}

.p012 {
  padding: 0 0px 0 12px;
}

.right-container {
  flex: 1;
  /* Allow the container to take up available space */
  margin-left: 0px;
  /* Add some spacing between the left and right containers */
  /* padding: 0 5px; */
}

.table-bordered td {
  border: 1px solid #dee2e6;
  /* Add the desired border style */
}
</style>
